/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS python filter api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GroundingSchema } from './GroundingSchema';
import {
    GroundingSchemaFromJSON,
    GroundingSchemaFromJSONTyped,
    GroundingSchemaToJSON,
} from './GroundingSchema';

/**
 * 
 * @export
 * @interface PageGroundingSchema
 */
export interface PageGroundingSchema {
    /**
     * 
     * @type {Array<GroundingSchema>}
     * @memberof PageGroundingSchema
     */
    items: Array<GroundingSchema>;
    /**
     * 
     * @type {number}
     * @memberof PageGroundingSchema
     */
    total: number | null;
    /**
     * 
     * @type {number}
     * @memberof PageGroundingSchema
     */
    page: number | null;
    /**
     * 
     * @type {number}
     * @memberof PageGroundingSchema
     */
    size: number | null;
    /**
     * 
     * @type {number}
     * @memberof PageGroundingSchema
     */
    pages?: number | null;
}

/**
 * Check if a given object implements the PageGroundingSchema interface.
 */
export function instanceOfPageGroundingSchema(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "items" in value;
    isInstance = isInstance && "total" in value;
    isInstance = isInstance && "page" in value;
    isInstance = isInstance && "size" in value;

    return isInstance;
}

export function PageGroundingSchemaFromJSON(json: any): PageGroundingSchema {
    return PageGroundingSchemaFromJSONTyped(json, false);
}

export function PageGroundingSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): PageGroundingSchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(GroundingSchemaFromJSON)),
        'total': json['total'],
        'page': json['page'],
        'size': json['size'],
        'pages': !exists(json, 'pages') ? undefined : json['pages'],
    };
}

export function PageGroundingSchemaToJSON(value?: PageGroundingSchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': ((value.items as Array<any>).map(GroundingSchemaToJSON)),
        'total': value.total,
        'page': value.page,
        'size': value.size,
        'pages': value.pages,
    };
}

